<template>
  <b-container fluid class="de-para-container">
    <el-tabs type="border-card">
      <el-tab-pane>
        <span slot="label"><i class="far fa-chart-bar"></i> De-Para </span>
        <container-card id="filtroConfigDePara" icon="fa-filter" title="Filtrar Informações de De-Para.">
          <el-form v-loading="loadingFiltroDepara" :model="modelFiltro" class="geral-form" ref="formFiltroDePara" size="mini" label-position="top" style="padding: 0 !important;">
              <b-card>
                <el-row :gutter="20">
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="12"
                    :xl="12"
                  >
                  <SelectMarcas v-model="modelFiltro.marcas" />
                  </el-col>
                  <el-col
                    :xs="24"
                    :sm="12"
                    :md="12"
                    :lg="12"
                    :xl="12"
                  >
                    <el-form-item :label="`Grupo${modelFiltro.clusterBool ? ' (Cluster)' : ''}:`" label-for="grupo" :prop="modelFiltro.clusterBool ? 'CustomerIds' : 'grupo'">
                      <div class="toogle-multiselect-cluster">
                          <small class="label-toogle-cluster">{{ modelFiltro.clusterBool ? 'Alterar para grupos' : 'Alterar para cluster' }}&nbsp;&nbsp;</small>
                          <el-switch v-b-popover.hover.top="'Alternar combo clusters/grupos.'"
                                      v-model="modelFiltro.clusterBool"></el-switch>
                      </div>
                      <div v-show="modelFiltro.clusterBool == false">
                          <el-select class="w-100" size="small"  filterable clearable multiple v-model="modelFiltro.CustomerIds" name="gruposSelect" placeholder="selecione">
                              <el-option
                              v-for="item in listas.grupos"
                                  :key="`grupo_${item.id}`"
                                  :label="item.label"
                                  :value="item.id">
                              </el-option>
                          </el-select>
                      </div>
                      <div v-show="modelFiltro.clusterBool == true">
                          <el-select class="w-100" size="small"  filterable clearable multiple v-model="modelFiltro.ClusterIds" name="gruposClusterSelect" placeholder="selecione">
                              <el-option
                                  v-for="item in listas.cluster"
                                  :key="`cluster_${item.id}`"
                                  :label="item.label"
                                  :value="item.id">
                              </el-option>
                          </el-select>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
                  <div slot="footer">
                      <div class="float-left btn-pesquisar">
                          <el-button size="small" @click.prevent="pesquisarDePara" type="primary" icon="el-icon-search">Pesquisar</el-button>
                          <el-button size="small" @click.prevent="limparFiltro" icon="el-icon-brush">Limpar</el-button>
                      </div>
                      
                      <div class="float-right btn-pesquisar">
                        <el-tooltip class="item" effect="dark" content="Gerar relatório" placement="left-end">
                          <el-popover
                              placement="bottom"
                              width="230"
                              v-model="gerarRelatorioVisivel">
                              <p>Deseja gerar um relatório com as informações de De-Para?</p>
                              <div style="text-align: right; margin: 0">
                                  <el-button size="mini" type="text" @click="gerarRelatorioVisivel = false">Não</el-button>
                                  <el-button type="primary" size="mini" @click="gerarRelatorio">Sim</el-button>
                              </div>
                              <el-button v-if="temAcesso('DePara','Exportar')" size="small" class="btn-gerar-relatorio" type="success" icon="el-icon-download" slot="reference"> Gerar relatório </el-button>
                              <el-button v-else class="btn-gerar-relatorio no-drop" size="small" disabled icon="el-icon-download" slot="reference" v-b-tooltip.hover title="Sem permissões"> Gerar relatório </el-button>
                          </el-popover>
                          
                        </el-tooltip>
                      </div>
                  </div>
              </b-card>
          </el-form>
        </container-card>

        
          <b-card>
            <div>
              <div class="float-left depara-tipo" :class="tipoName">
                <h2>
                  <i v-if="tipoName === 'Franqueado'" class="fas fa-user"></i>
                  <i v-else class="fas fa-users"></i>
                  {{ tipoName }}
                </h2>
                <el-switch
                class="depara-tipo-sw"
                  v-model="tipoDepara"
                  active-color="#13ce66"
                  inactive-color="#6b76ff"
                  title="Tipo de De-para - Franqueado/Franqueador">
                </el-switch>
              </div>
              <div class="float-right depara-tipo">
                <el-tooltip class="item" effect="dark" content="Vincular planos de contas com nomes iguais automaticamente" placement="left-end">
                  <el-button v-if="temAcesso('DePara','VinculoAutomatico')" size="small" :disabled="vincularAutomaticamenteDisabled" type="success" @click="vincularAutomaticamente"> Vincular Automaticamente </el-button>
                  <el-button v-else size="small" :disabled="true" v-b-tooltip.hover title="Sem permissões"> Vincular Automaticamente </el-button>
                </el-tooltip>
              </div>
            </div>
            <el-table
            class="p-table depara-table"
            v-loading="tableOptions.load"
            :data="tableOptions.data"
            style="width: 100%"
            stripe
            border
            size="mini">
            
            
              <el-table-column
              prop="grupo"
              label="Grupo"
              sortable
              align="left">
                <template slot-scope="scope" v-if="scope.row">
                  {{ scope.row.grupo.nome }}
                </template>
              </el-table-column>
            
              <el-table-column
              prop="pendente"
              label="Pendente"
              align="center"
              sortable
              width="150">
                <template slot-scope="scope" v-if="scope.row">
                  <router-link :to="{name: `de-para-${tipoNameFormater()}-pendente`, params: { customerId: scope.row.grupo.id }, query: { marcas: modelFiltro.marcas.join(','), nome: scope.row.grupo.nome }}" class="el-button cursor-pointer depara-table-btn el-button--red el-button--mini">
                    <i class="el-icon-edit-outline"></i>
                    {{ scope.row.pendente }}
                  </router-link>
                </template>
              </el-table-column>
          
              <el-table-column
              prop="revisao"
              label="Revisão"
              align="center"
              sortable
              width="150">
              <template slot-scope="scope" v-if="scope.row">
                  <router-link :to="{name: `de-para-${tipoNameFormater()}-revisao`, params: { customerId: scope.row.grupo.id }, query: { marcas: modelFiltro.marcas.join(','), nome: scope.row.grupo.nome }}" class="el-button cursor-pointer depara-table-btn el-button--red el-button--mini">
                    <i class="el-icon-edit-outline"></i>
                    {{ scope.row.revisao }}
                  </router-link>   
                </template>
              </el-table-column>
        
              <el-table-column
              prop="aprovado"
              label="Aprovado"
              align="center"
              sortable
              width="150">
              <template slot-scope="scope" v-if="scope.row">
                  <router-link :to="{name: `de-para-${tipoNameFormater()}-aprovado`, params: { customerId: scope.row.grupo.id }, query: { marcas: modelFiltro.marcas.join(','), nome: scope.row.grupo.nome }}" class="el-button cursor-pointer depara-table-btn el-button--red el-button--mini">
                    <i class="el-icon-edit-outline"></i>
                    {{ scope.row.aprovado }}
                  </router-link>         
                </template>
              </el-table-column>
      
            </el-table><br>
            <el-pagination
            class="text-center"
            background
            layout="sizes, prev, pager, next"
            @size-change="paginacaoSize"
            @current-change="paginacaoCurrent"
            :page-size="tableOptions.paginacao.pageSize"
            :current-page.sync="tableOptions.paginacao.page"
            :total="tableOptions.paginacao.total"
            :page-sizes="[5, 10, 25, 50, 75, 100]">
            </el-pagination>
          </b-card>
        
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label"><i class="fa fa-wrench"></i> Solicitações</span>
        <Solicitacoes />
      </el-tab-pane>
    </el-tabs>
  </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import SelectMarcas from '@/components/shared/SelectMarcas'
import Solicitacoes from './Solicitacoes'

const modelFiltro = () => {
        return {
            CustomerIds: [],
            ClusterIds: [],
            marcas: [],
            clusterBool: false
        }
    }

export default {
  name: 'DePara',
  components: {
    ContainerCard,
    SelectMarcas,
    Solicitacoes
  },
  data() {
    return {
      model: {
        nome: ''
      },
      windowHeight: window.innerHeight,
      tipoDepara: true,
      loadingFiltroDepara: false,
      modelFiltro: modelFiltro(),
      gerarRelatorioVisivel: false,
      tableOptions: {
        load: false,
        data: [],
        paginacao: {
          page: 1,
          pageSize: 10,
          total: 10
        }
      },
      listas: {
        grupos: [],
        cluster: []
      },
      vincularAutomaticamenteDisabled: false
    }
  },
  computed: {
    tipoName() {
      return this.tipoDepara === true ? 'Franqueado' : 'Franqueador'
    }
  },
  methods: {
    tipoNameFormater() {
      return this.tipoName.toLowerCase() || ''
    },
    pesquisarDePara() {
      this.listarDePara();
    },
    limparFiltro() {
      this.modelFiltro = modelFiltro()
    },
    paginacaoCurrent(val){
      this.tableOptions.paginacao.page = val
      this.listarDePara();
    },
    paginacaoSize(val){
      this.tableOptions.paginacao.pageSize = val
      this.tableOptions.paginacao.page = 1
      this.listarDePara();
    },
    gerarRelatorio() {
        this.requestGerarRelatorio();
        this.gerarRelatorioVisivel = false;
    },
    async requestGerarRelatorio(){
        let request = await this.axios.get(this.$urls.DE_PARA_GERACAO_RELATORIO, {
                params: {
                    CustomerIds: this.modelFiltro.CustomerIds.join(','),
                    ClusterIds: this.modelFiltro.ClusterIds.join(','),
                    marcas: this.modelFiltro.marcas.join(',')
                }
            });

        if(request.status !== 200) {
            this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
            return;
        }

        this.$notify({
            type: "success",
            title: 'Gerando Relatório',
            dangerouslyUseHTMLString: true,
            message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
        });
    },
    async listarDePara() {
      try {
        this.tableOptions.load = true;
        
        const response = await this.axios.get(this.$urls.DE_PARA_LISTAR, {
          params: {
            page: this.tableOptions.paginacao.page,
            pageSize: this.tableOptions.paginacao.pageSize,
            Order: '', // verificar como vai ser a ordenação

            marcas: this.modelFiltro.marcas.join(','),
            CustomerIds: this.modelFiltro.CustomerIds.join(','),
            ClusterIds: this.modelFiltro.ClusterIds.join(','),
            Visao: this.tipoNameFormater()//'Franqueado' // Franqueado ou Franqueador
          }
        });
        
        this.tableOptions.load = false
        
        if(response.status !== 200){
          this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
          return;
        }
        
        this.tableOptions.data = response.data.valores;
        this.tableOptions.paginacao.page = response.data.page;
        this.tableOptions.paginacao.total = response.data.total;
      } catch(err) {
        this.$notify.error({
          title: 'Erro interno',
          message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
          position:'top-left'
        });
      }finally {
        this.tableOptions.load = false
      }
    },
    async getListas(optModel, route) {
      let response = await this.axios.get(route);

      if(response.status !== 200) {
          return;
      }

      this.$data.listas[optModel] = response.data;
    },
    async vincularAutomaticamente() {
      this.vincularAutomaticamenteDisabled = true;

      try {
        const response = await this.axios.post(this.$urls.DE_PARA_VINCULAR_AUTOMATICAMENTE);

        if(response.data){
          this.$message.error(response.data);
          this.vincularAutomaticamenteDisabled = false;
          return;
        }
                
        if(response.status !== 200){
          this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
          this.vincularAutomaticamenteDisabled = false;
          return;
        }

        this.$notify({
            type: "success",
            title: 'Vinculando automaticamente',
            dangerouslyUseHTMLString: true,
            message: `Sua solicitação de vinculo automático foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
        });

        setTimeout(() => {
          this.vincularAutomaticamenteDisabled = false;
        }, 900000); //15 min
      } catch(err) {
        this.$notify.error({
          title: 'Erro interno',
          message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
          position:'top-left'
        });
      }
    }
  },
  mounted() {
    this.getListas('cluster', this.$urls.CLUSTERS);
  },
  watch:{
   async tipoDepara(){
      await this.pesquisarDePara();
    },
    'modelFiltro.marcas': function() {
      var marcas = this.modelFiltro.marcas;
      this.modelFiltro.CustomerIds = [];
        if (marcas.length) {
          if (marcas.length > 1 && marcas.includes('0')) {
            return;
          }
          this.getListas('grupos', `${this.$urls.GRUPOS}?marcas=${marcas.join(',')}`);
        }
    }
  }
};
</script>
<style lang='scss' scoped>
.depara-tipo {
  position:relative;
  h2 {
    font-size: 1.6rem; 
  }
  .fas {
    width: 35px;
    font-size: 23px;
    padding: 4px;
    text-align: center;
  }
  &-sw {
    position:absolute;
    /* right: 0;
    top: 4px; */
    left: 207px;
    top: 8px;
  }
}
.depara-table-btn {
  min-width:70px;
}
</style>
<style lang="scss">
.depara-table {
  .el-table__header-wrapper table{
    thead th.el-table__cell{
      &:nth-of-type(2) {
        border-bottom: 2px solid #ff604b;
      }
      &:nth-of-type(3) {
        border-bottom: 2px solid #ffb56b;
      }
      &:nth-of-type(4) {
        border-bottom: 2px solid #5aca78;
      }
    }
  }
}
.de-para-container {
  .toogle-multiselect-cluster {
    position: absolute;
    top: -30px;
    right: 6px;
  }
}
</style>
